import PropTypes from 'prop-types';

const EditionType = PropTypes.string;

export default EditionType;
